module.exports = __webpack_public_path__ + "media/1x1/tw-26cc9d59.svg";